export default __webpack_public_path__ + "static/media/closeWhite.48eeefbb.svg";